import { StyledHeader } from './styledHeader';
import { StyledFooter } from './styledFooter';
export { StyledHeader, StyledFooter };